module.exports = __webpack_public_path__ + "img/icon-speed-light.411dedc9.svg";